import { AthleteRabbit, RosterEntries } from "./SegmentAnalysisMap.types";

export const buildAthletes = (rosterEntries: RosterEntries): AthleteRabbit[] => {
  const { baseline } = rosterEntries;
  const baselineAthletes: AthleteRabbit[] = baseline ? [{
    id: baseline.get('id'),
    name: baseline.get('display_name'),
    photoUrl: baseline.get('photo'),
    index: 0,
    latlngStream: baseline.get('streams')?.latlng ?? null,
  }] : [];

  const comparisonAthletes = rosterEntries.getComparisonEntries().map((entry) => ({
    id: entry.get('id'),
    name: entry.get('display_name'),
    photoUrl: entry.get('photo'),
    index: rosterEntries.getPosition(entry),
    latlngStream: entry.get('delta')?.latlng ?? null,
  }));

  return baselineAthletes.concat(comparisonAthletes);
};

export default buildAthletes;
